import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  VERIFY_2F,
  VERIFY_2F_SUCCESS,
  VERIFY_2F_LOGIN,
  VERIFY_2F_LOGIN_SUCCESS,
  LOGIN_API_ERROR,
  SEND_VERIFICATION_CODE_SUCCESS,
  SEND_VERIFICATION_CODE,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
}

const login = (state = initialState, action) => {
  switch (action.type) {
    
    case LOGIN_USER:
    case VERIFY_2F:
    case VERIFY_2F_LOGIN:  
    case SEND_VERIFICATION_CODE:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_SUCCESS:
    case VERIFY_2F_SUCCESS:
    case VERIFY_2F_LOGIN_SUCCESS:
    case SEND_VERIFICATION_CODE_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case LOGOUT_USER:
      state = { ...state }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state }
      break
    case LOGIN_API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
